// extracted by mini-css-extract-plugin
export default {"myModal":"CreateInvoiceInformationModal_myModal__MKNw4"};